import React, { useState, useEffect, useContext } from 'react';

import {
	Container,
	IconButton,
	Paper,
	TableContainer,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Table,
	Typography,
	Stack,
	TextField,
	InputAdornment,
	Chip,
	Tooltip
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrashAlt, faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { isEmpty } from 'lodash';
import SmallModal from '../../../components/modals/SmallModal';

import Swal from 'sweetalert2';
import { DataContext } from '../../../context/DataContext';
import { deleteToken, deleteUserData, getToken } from '../../../api/Account';
import { getRuta, isAccess, simpleMessage } from '../../../helpers/Helpers';
import { deleteUserSessionAsync, getUserSessionsAsync } from '../../../api/Users';
import NoData from '../../../components/NoData';
import { PaginationComponent } from '../../../components/PaginationComponent';
import moment from 'moment';
import IntentoLoginList from './IntentoLoginList';
import MediumModal from '../../../components/modals/MediumModal';
const SessionList = () => {
	const [sessionList, setSessionList] = useState([]);
	const [userId, setUserId] = useState(0);

	const [localReload, setLocalReload] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const { setIsLoading, setIsLogged, setIsUnautorized, access } = useContext(DataContext);

	const token = getToken();

	const [searchTerm, setSearchTerm] = useState('');

	const withSearch = sessionList.filter((val) => {
		if (searchTerm === '') {
			return val;
		} else if (
			val.id.toString().includes(searchTerm) ||
			val.fullName.toString().toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
			val.rolName.toString().toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())
		) {
			return val;
		}
	});

	const getData = async () => {
		setIsLoading(true);
		let result = await getUserSessionsAsync(token);

		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		// console.log(result.data.result);
		setSessionList(result.data.result);
		setIsLoading(false);
	};

	useEffect(() => {
		getData();
	}, [localReload]);

	const onChangeSearch = (val) => {
		setSearchTerm(val);
	};

	const deleteSession = async (id) => {
		Swal.fire({
			title: '¿Estas Seguro?',
			text: 'No podras revertir esto...!',
			icon: 'warning',
			showCancelButton: true,

			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',

			confirmButtonText: 'Eliminar!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const result = await deleteUserSessionAsync(token, id);
					if (!result.statusResponse) {
						setIsLoading(false);
						if (result.error === 'Unauthorized') {
							setIsUnautorized(true);
							return;
						}
						simpleMessage(result.error, 'error');
						return;
					}
					if (result.error === 'eX01') {
						setIsLoading(false);
						deleteUserData();
						deleteToken();
						setIsLogged(false);
						return;
					}
					setIsLoading(false);
					setLocalReload(!localReload);
					Swal.fire('Eliminado!', 'Session Eliminada.', 'success');
				})();
			}
		});
	};

	return (
		<div>
			<Container maxWidth="xl">
				<Paper
					style={{
						padding: 20,
						textAlign: 'center'
					}}
				>
					<Typography color={'#00a152'} variant="h6" fontWeight={'bold'} textAlign="left">
						Lista de Sesiones de Usuarios
					</Typography>

					<hr />

					<TextField
						style={{ marginTop: 20, marginBottom: 20, maxWidth: 600 }}
						fullWidth
						onChange={(e) => onChangeSearch(e.target.value.toUpperCase())}
						value={searchTerm}
						label={'Buscar usuario'}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton>
										<FontAwesomeIcon
											icon={faSearch}
											style={{ color: '#2979ff' }}
										/>
									</IconButton>
								</InputAdornment>
							)
						}}
					/>

					{isEmpty(withSearch) ? (
						<NoData />
					) : (
						<Stack spacing={2}>
							<TableContainer>
								<Table aria-label="simple table" size="small">
									<TableHead>
										<TableRow>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												#
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Nombre Completo
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Rol
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												S.O.
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Sucursales
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Plataforma
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Id Dispositivo
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Version
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Expira
											</TableCell>

											{isAccess(access, 'SECURITY UPDATE') ? (
												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Acciones
												</TableCell>
											) : null}
										</TableRow>
									</TableHead>
									<TableBody>
										{withSearch.map((row) => {
											const {
												deviceId,
												userId,
												expira,
												fullName,
												id,
												rolName,
												sucursalsAccess,
												userBrowser,
												userSO,
												version
											} = row;

											return (
												<TableRow key={id}>
													<TableCell
														align="center"
														component="th"
														scope="row"
													>
														{id}
													</TableCell>
													<TableCell align="left">{fullName}</TableCell>
													<TableCell align="left">{rolName}</TableCell>
													<TableCell align="center">{userSO}</TableCell>
													<TableCell align="center">
														<Stack spacing={1}>
															{sucursalsAccess.map((i) => (
																<Chip
																	key={i.id}
																	label={i.description}
																	variant="outlined"
																	color="primary"
																/>
															))}
														</Stack>
													</TableCell>
													<TableCell align="center">
														{userBrowser}
													</TableCell>
													<TableCell align="center">{deviceId}</TableCell>
													<TableCell align="center">{version}</TableCell>
													<TableCell align="center">
														{moment(expira).format('L')}
													</TableCell>

													{isAccess(access, 'SECURITY UPDATE') ? (
														<TableCell align="center">
															<Stack
																direction={'row'}
																spacing={1}
																justifyContent="center"
															>
																<Tooltip
																	title="Ver intentos de sesión"
																	arrow
																>
																	<IconButton
																		style={{
																			color: '#ffc400'
																		}}
																		onClick={() => {
																			setUserId(userId);
																			setShowModal(true);
																		}}
																	>
																		<FontAwesomeIcon
																			icon={faExternalLink}
																		/>
																	</IconButton>
																</Tooltip>

																<Tooltip
																	title="Eliminar Sesión"
																	arrow
																>
																	<IconButton
																		style={{
																			color: '#f50057'
																		}}
																		onClick={() => {
																			deleteSession(id);
																		}}
																	>
																		<FontAwesomeIcon
																			icon={faTrashAlt}
																		/>
																	</IconButton>
																</Tooltip>
															</Stack>
														</TableCell>
													) : null}
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</Stack>
					)}
				</Paper>
			</Container>

			<MediumModal
				titulo="Intentos de Sesión"
				isVisible={showModal}
				setVisible={setShowModal}
			>
				<IntentoLoginList userId={userId} />
			</MediumModal>
		</div>
	);
};

export default SessionList;
